import { parseNumberQuery, useQueryParams } from 'utils/hooks/useQueryParams'

export const useBirthdaysQueryParams = () => {
  const params = useQueryParams<{ months: string[] | string; organisation: string }>()
  return { ...params, selectedMonths: parseNumberQuery(params.params.months) }
}
